import { createStyles } from '@mantine/core';

export const useMenuStyles = createStyles(() => {
  return {
    dropdown: {
      border: 'none',
      padding: 0,
      backgroundColor: 'transparent',
    },
  };
});
export const useAutocompleteStyles = createStyles(
  (_, params: { open: boolean }) => {
    if (params.open) {
      return {
        input: {
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
        },
      };
    }

    return {
      input: {},
    };
  },
);
